export default __webpack_public_path__ + "static/contact_big-e2e89f1027bd4c3500721792b065fc18.png";